import Head from 'next/head'
import { useRouter } from 'next/router'
import React from 'react'

import { useIntl } from 'react-intl'

import useDocumentsPage from '@/hooks/useDocumentsPage'

import Loader from '@/components/Loader'

interface DocumentTitle {
  id: string
  defaultMessage: string
}

const DocumentsPage = () => {
  const router = useRouter()
  const { formatMessage } = useIntl()
  const { document, isLoading } = useDocumentsPage()

  const title =
    router.query.name && getCurrentTitle(router.query.name as string)

  return (
    <div className="pb-5 tablet:pb-8 desktop:pb-17 desktop:pt-2">
      <Head>
        <title>{`${title ? formatMessage(title) + '—' : ''} Asterbit`}</title>
      </Head>
      {isLoading ? (
        <Loader />
      ) : (
        <div
          className="mb-4 space-y-3 tablet:mb-5 desktop:mb-10"
          dangerouslySetInnerHTML={{ __html: document || '' }}
        />
      )}
    </div>
  )
}

export default DocumentsPage

const getCurrentTitle = (title: string) => {
  const documentTitles: {
    [key: string]: DocumentTitle
  } = {
    privacy_policy: {
      id: 'documents.privacyPolicy',
      defaultMessage: 'Политика конфиденциальности'
    },
    terms_of_service: {
      id: 'documents.termsOfService',
      defaultMessage: 'Условия оказания услуг'
    }
  }

  return documentTitles[title]
}
